import React, { Component } from 'react'
import Avatar from 'react-avatar';

class UserAvatar extends Component {
  constructor(props) {
    super(props);
}

  render() {
      const username=this.props.username;
      const commentuserid=this.props.commentuserid;
      const url='http://oct-user-images-' + this.props.stage + '.s3.eu-west-2.amazonaws.com/' + commentuserid + '.png';
      const userid=this.props.userid;

    return(<Avatar 
            src={url}
            name={username ? username : "Not Available"}
            size={40}
            textSizeRatio={3}
            round={true}
            color={userid==commentuserid ? "#015872" : "lightgrey"}
            fgColor={userid==commentuserid ? "lightgrey" : "#015872"}
        ></Avatar>
        );
  }
}

export default UserAvatar;